// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"459":"about-page","671":"card-detail-page"}[chunkId] + "." + {"459":"8c5b220b","671":"954d9f42"}[chunkId] + ".css";
};